<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-responsive-sm">
          <thead>
              <tr>
                <th>{{ $t("labels.drug") }}</th>
                <th>{{ $t("labels.quantity") }}</th>
                <th>{{ $t("labels.bloodLevel") }}</th>
                <th>{{ $t("labels.drugNotes") }}</th>
                <th>{{ $t("labels.startDate") }}</th>
                <th>{{ $t("labels.endDate") }}</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="d in item.drugs" :key="d._id">
                <td>{{ d.name[$i18n.locale] ? d.name[$i18n.locale] : d.name['en'] }}</td>
                <td>{{ d.quantity ? d.quantity : '' }}</td>
                <td>{{ d.bloodLevel ? d.bloodLevel : '' }}</td>
                <td>{{ d.notes ? d.notes : '' }}</td>

              </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-if="item.notes">
      <div class="col-md-12">
        <h5>{{ $t("labels.therapyNotes") }}</h5>
        <div v-html="item.notes"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ["item"]
}
</script>

<style lang="scss" scoped>
    .card {
        min-height: 140px;
    }

   svg {
         max-width: 100px;
       }
</style>


